<template>
  <div
    @click="passMethod('click')"
    :class="[classes, $platformClass, pointClass]"
    class="j-inner-pay-btn"
  >
    <div class="inner-tips" style="display: none;">
      {{ languages.morePurchaseWay }}
    </div>
    <div v-if="isDlssr || isDl3dvn || isBeast" class="inner-game-logo" :class="[curLanguage]"></div>
    <span :class="[logoClass, $platformClass]"></span>
    <Button class="pay-btn" type="selectInnerWay">
      {{ (isMuglo || isBeast || isDlssr || isDl3dvn) ? languages.payBtn : languages.payBtnText }}
      <Icon v-if="!$isOmni" type="selectInnerPay"></Icon>
    </Button>
  </div>
</template>

<script>
import themeMixins from '../../mixins/themeMixins';
export default {
  mixins: [themeMixins],
  props: ['languages', 'logoClass', 'isMuglo', 'isBeast', 'isDlssr', 'isDl3dvn', 'curLanguage'],
};
</script>
